import { FC } from 'react';
import ISvgProps from '../SvgLoader/ISvgProps';

export const ExclamationMarkIconSmall: FC<ISvgProps> = ({ primaryColor = '#D23C3C' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
			<path
				d="M8 14C4.6862 14 2 11.3138 2 8C2 4.6862 4.6862 2 8 2C11.3138 2 14 4.6862 14 8C14 11.3138 11.3138 14 8 14ZM7.4 7.4V11H8.6V7.4H7.4ZM7.4 5V6.2H8.6V5H7.4Z"
				fill={primaryColor}
			/>
		</svg>
	);
};
